import axios from 'axios';
import { MINUTES_TO_MS, configRefs } from '@utils/constants';

const getStatusForProductQuery = productId => {
  return {
    queryKey: ["user-area/get-status-for-product", productId],
    queryFn: () => getStatusForProduct(productId),
    retry: false,
    staleTime: 30 * MINUTES_TO_MS,
    meta: {
      persist: false
    }
  };
};
async function getStatusForProduct(productId) {
  if (!productId) {
    return [];
  }
  const res = await axios.get(`${await configRefs.apis.status.get()}/api/driftstatus.svc/GetDriftstatusByProductID?productID=${productId}`);
  return res.data.map(it => ({
    createdAt: new Date(it.created * 1000),
    title: it.title,
    url: it.infoUrl,
    urgent: it.urgent
  }));
}

export { getStatusForProduct, getStatusForProductQuery };
//# sourceMappingURL=api.get-status.js.map
